import { FieldFlags } from "vee-validate";

const stepInfo = [
  {key: 'step1', title: 'Create your account'},
  {key: 'step2', title: 'Setup your portal'},
  {key: 'step3', title: 'Upload your design'},
  {key: 'step4', title: 'Share with your team'},
]

export default {
  state: {
    heroState: null,
    onboardingHidden: false
  },
  mutations: {
    hideOnboarding(state) {
      state.onboardingHidden = true;
    },
    setHeroState(state, heroState) {
      state.heroState = heroState;
    }
  },
  actions: {
    setInitialHeroState({commit, dispatch, getters}) {
      if (getters.allDone) {
        commit('setHeroState', 'allDone');
      } else {
        commit('setHeroState', 'init');
        dispatch('nextHeroState');
      }
    },
    setHeroState({commit}, heroState) {
      commit('setHeroState', heroState);
    },
    nextHeroState({state, getters, commit}) {
      let advance = {
        init: 'step1',
        step1: 'step2',
        step2: 'step3',
        step3: 'step4',
        step4: 'step1'
      }, cur = advance[state.heroState], n = 10;
      while (getters[cur] && cur && n--) {
        if (cur === 'step4') {
          cur = 'allDone';
          break;
        } else {
          cur = advance[cur];
        }
      }
      commit('setHeroState', cur);
    },
    hideOnboarding({commit}) {
      commit('hideOnboarding');
    }
  },
  getters: {
    heroState: state => state.onboardingHidden ? 'hide' : state.heroState,
    steps: (state, getters) => stepInfo.map(({key, title}) => ({key, title, done: getters[key], active: state.heroState === key})),
    onboardingHidden: (state,  getters) => (state.onboardingHidden && !getters.flags.forceOnboarding) || state.heroState == 'allDone',
    // Create your acount. Pretty much always true.
    step1: state => true,
    // Setup your portal. Have they answered the welcome questions.
    // For now, assume so.
    step2: state => true,
    // Upload your design.
    // When they have a design, its true
    step3: (state, getters) => !!getters.productTemplateDesignId,
    // Share with your team
    // have they invited at least one person BESIDES themselves?
    step4: (state, getters) => getters.team.members_qty || 0 > 1,
    allDone: (state, getters) => getters.step1 && getters.step2 && getters.step3 && getters.step4
  }
}



// WEBPACK FOOTER //
// ./src/store/onboard.js